var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M5.434,14.307l-5.2-5.23a.808.808,0,0,1,0-1.138L1.366,6.8A.8.8,0,0,1,2.5,6.8L6,10.325l7.5-7.546a.8.8,0,0,1,1.131,0l1.131,1.138a.808.808,0,0,1,0,1.138l-9.2,9.253A.8.8,0,0,1,5.434,14.307Z",
    transform: "translate(0 -2.543)",
    fill: "#025376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7e18a8bdf8a33d9ef4e3456fff0825a5.svg";
export { ForwardRef as ReactComponent };